import React, { useState } from "react";
import Card from "@/components/Card";
import { useSelector } from "react-redux";
import { DashSel } from "@/features/dashboard";

import ExchangeSelect from "./ExchangeSelect";
import GroupSelect from "./GroupSelect";
import { BenchmarkContext } from "./hook";
import { Checkbox, Col, Row } from "antd";
import LeftPane from "./LeftPane";
import Content from "./Content";

export default () => {
  const defaultBenchmarkExchange = useSelector(DashSel.defaultBenchmarkExchange);
  const investmentStyles = useSelector(DashSel.availableInvestmentStyle(defaultBenchmarkExchange));
  const groups = useSelector(DashSel.availableGroup(defaultBenchmarkExchange));
  const [exchange, setExchange] = useState(defaultBenchmarkExchange);
  const [group, setGroup] = useState(groups.slice(0, 1));
  const [isAll, setIsAll] = useState(false);
  const [selectedKey, setSelectedKey] = useState<string[]>(
    investmentStyles.length > 0 ? investmentStyles.slice(0, 4) : []
  );

  return (
    <BenchmarkContext.Provider
      value={{ isAll, exchange, setExchange, group, setGroup, selectedKey, setSelectedKey, investmentStyles, groups }}
    >
      <Card
        title={"Benchmark Analysis"}
        bodyStyle={{ overflow: "hidden" }}
        extra={[
          <Checkbox checked={isAll} onChange={e => setIsAll(e.target.checked)} key={"show-all"}>
            Show All
          </Checkbox>,
          <GroupSelect key={"group-select"} />,
          <ExchangeSelect key={"exchange-select"} />
        ]}
      >
        <Row justify={"space-between"}>
          <Col span={3}>
            <LeftPane />
          </Col>
          <Col span={20}>
            <Content />
          </Col>
        </Row>
      </Card>
    </BenchmarkContext.Provider>
  );
};
